// /refresh — loaded in a hidden frame by a Redwood app (crm, …) whose rw_token
// is about to run out. Renews the Cognito tokens with Amplify's refresh token
// (kept in this origin's storage), rewrites the shared rw_token cookie, and
// tells the framing page { type: 'rw-token-refreshed', ok }. The token itself
// is never posted: the app reads the cookie, as it always does. Answers only a
// page on *.redwoodoperations.com that framed it; never shows the sign-in form.

import { fetchAuthSession } from 'aws-amplify/auth';
import { setIdTokenCookie } from './cookie.js';

const TRUSTED_ORIGIN = /^https:\/\/([a-z0-9-]+\.)*redwoodoperations\.com$/;

export const isRefreshPage = () => window.location.pathname === '/refresh';

export async function runSilentRefresh(): Promise<void> {
  const origin = new URLSearchParams(window.location.search).get('origin') ?? '';
  if (window.parent === window || !TRUSTED_ORIGIN.test(origin)) return;
  let ok = false;
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    const idToken = session.tokens?.idToken?.toString();
    if (idToken) {
      setIdTokenCookie(idToken);
      ok = true;
    }
  } catch (err) {
    console.warn('silent refresh failed', err); // no refresh token (signed out, or 30 days passed): the app sends the user to sign in
  }
  window.parent.postMessage({ type: 'rw-token-refreshed', ok }, origin);
}
